import { combineReducers } from 'redux';
import user from './userReducers';
import salesforceReducers from './salesforceReducers';
import objectInfo from './objectInfoReducers';
import form from './formReducers';
import registration from './registrationReducers';


// const rootReducers = combineReducers({
//     user,
//     objectInfo,
//     salesforce: salesforceReducers,
// });

const appReducers = combineReducers({
    user,
    objectInfo,
    form,
    salesforce: salesforceReducers,
    registration,
});
const rootReducers = (state, action) => {
    if (action.type === 'LOGGED_OUT') {
        state = undefined;
    }
    return appReducers(state, action);
};

export default rootReducers;



//////////////////
// WEBPACK FOOTER
// ./src/reducers/index.js
// module id = 1066
// module chunks = 0